@if (fileViewModel()) {
  <mat-card
    class="file-description-card"
    [class.mini-image]="miniImage()"
    [appearance]="miniImage() ? 'outlined' : 'raised'">
    <mat-card-header>
      @if (miniImage() && isImageFile()) {
        <img mat-card-avatar [src]="fileViewModel().PublicUrl" [alt]="fileViewModel().alt" />
      } @else {
        <div mat-card-avatar>
          <mat-icon>{{ getIcon() }}</mat-icon>
        </div>
      }
      <mat-card-title>
        @if (fileViewModel().PublicUrl && !miniImage() && !fileViewModel().isNew) {
          <a href="{{ fileViewModel().PublicUrl }}" target="_attachment">{{ fileViewModel().FileName }}</a>
        } @else {
          <span>{{ fileViewModel().FileName }}</span>
        }
      </mat-card-title>
      <mat-card-subtitle>
        @if (fileViewModel().DateCreated) {
          <span>{{ getDate() | date: 'short' }} - </span>
        }
        <span>{{ fileViewModel().FileSize }}</span>
        @if (fileViewModel().OwnerId != null) {
          <div>
            <span>{{ 'Files.Table.OwnerId' | translate: locale.language }}: </span>
            @if (canViewAdmins && uploadedBy()) {
              <a [routerLink]="['/admins', fileViewModel().OwnerId]" target="_blank">{{ uploadedBy() }}</a>
            } @else {
              {{ fileViewModel().OwnerId }}
            }
          </div>
        }
      </mat-card-subtitle>
    </mat-card-header>
    @if (!miniImage()) {
      @switch (contentType()) {
        @case ('image') {
          <img mat-card-image [src]="fileViewModel().PublicUrl" [alt]="fileViewModel().alt" />
        }
        <!-- TODO: we could handle displaying other files types in the future -->
        @default {}
      }
    }
    <mat-card-content>
      <div class="file-description-container" [class.mat-small]="miniImage()">
        <div class="file-description-field">
          @if (isDisabled()) {
            <mat-error>
              {{ 'Alert.Attachments.NoAltTextOnUpload' | translate: locale.language }}
            </mat-error>
          }
          @if (isDisabled() || fileDescription().dirty) {
            <p>{{ descriptionInstructions() | translate: locale.language }}</p>
          }
          <mat-form-field appearance="outline">
            <mat-label>{{ fileViewModel().label | translate: locale.language }}</mat-label>
            <textarea id="file-description" matInput type="text" [formControl]="fileDescription()"></textarea>
            <mat-hint>{{ fileViewModel().hint | translate: locale.language }}</mat-hint>
          </mat-form-field>
        </div>
        <!-- TODO: We need to update the api to use the new resize code -->
        <!-- @if (fileViewModel().isImageFile && fileResize && fileViewModel().isNew) {
          <div class="file-description-field">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Files.Shared.ResizeImage' | translate: locale.language }}</mat-label>
              <input [formControl]="fileResize()" matInput type="number" min="1" />
              <mat-hint>{{ 'Files.Shared.ResizeImageHint' | translate: locale.language }}</mat-hint>
            </mat-form-field>
          </div>
        } -->
      </div>
    </mat-card-content>
    @if (actions?.length > 0) {
      <mat-card-actions>
        @for (action of actions; track action.label) {
          <button
            mat-stroked-button
            [color]="action.color"
            (click)="action.emit()"
            [disabled]="action.disabled"
            [attr.aria-label]="action.tip | translate: locale.language">
            <mat-icon>{{ action.icon }}</mat-icon>
            {{ action.label | translate: locale.language }}
          </button>
        }
      </mat-card-actions>
    }
  </mat-card>
}
